var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_17740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8787 15.6367L21.4999 28.0155L14.9848 21.5004L5.21205 31.2731M33.8787 15.6367H26.0605M33.8787 15.6367V23.4549",
    stroke: "#008080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 20,
    stroke: "#008080",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_17740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.2727,
    height: 31.2727,
    fill: "white",
    transform: "translate(3.909 7.81836)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapital);
export default __webpack_public_path__ + "static/media/capital.21c1ca9fe9aa693192a1f74e1305b863.svg";
export { ForwardRef as ReactComponent };